import Vue from "vue";
import VueRouter from "vue-router";

import store from "./store";
// import config from "../config.js";
import axios from "axios";

import Home from "../views/Home.vue";
//import HomePublic from "../views/HomePublic.vue";
import OfferList from "../views/OfferList.vue";
import OfferDistrict from "../views/OfferDistrict.vue";
import OfferDetails from "../views/OfferDetails.vue";
// import ImmoCaddy from "../views/ImmoCaddy.vue";
// import Account from "../views/Account.vue";
import Contact from "../views/Contact.vue";
import Whoweare from "../views/Whoweare.vue";
import Sitemap from "../views/Sitemap.vue";
import Partners from "../views/Partners.vue";
import LegalNotice from "../views/LegalNotice.vue";
import Login from "../views/Login.vue";

// import ImmoHome from "../views/ImmoHome.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "homeredirect",
    component: Home,
    meta: { readUrlSchool: true }
    // redirect: "/home"
  },
  {
    path: "/home",
    name: "home",
    component: Home,
    meta: { readUrlSchool: true }
    // redirect: "/immo/isbatp/page/1"
  },
  // {
  //   path: "/immo/:schoolslug",
  //   name: "immohomeschool",
  //   component: ImmoHome,
  //   meta: { readUrlSchool: true }
  //   // redirect: "/immo/isbatp/page/1"
  // },
  {
    path: "/offers",
    name: "offers",
    component: OfferList
    // redirect: "/offers/page/1"
  },
  {
    path: "/offers/favories",
    name: "offers-favories",
    component: OfferList
    // redirect: "/offers/page/1"
  },

  {
    path: "/offers/:where/:salerent/:types/:pieces/:budget/:page",
    name: "offerspage",
    component: OfferList,
    meta: { publicpage: true, readUrlSchool: true }
  },

  {
    path: "/offers/details/:slug",
    name: "offerdetails",
    component: OfferDetails,
    meta: { publicpage: true, readUrlSchool: true }
  },

  {
    path: "/offers/:salerent/:where",
    name: "offersdistrict",
    component: OfferDistrict,
    meta: { publicpage: true, readUrlSchool: true }
  },

  // {
  //   path: "/immo/:schoolslug/offer/:slug",
  //   name: "immoofferdetails",
  //   component: ImmoOfferDetails,
  //   meta: { publicpage: true, readUrlSchool: true }
  // },
  // {
  //   path: "/immo/caddy",
  //   name: "immocaddy",
  //   component: ImmoCaddy,
  //   meta: { publicpage: true }
  // },
  // {
  //   path: "/account",
  //   name: "account",
  //   component: Account,
  //   meta: { publicpage: true }
  // },
  {
    path: "/contact",
    name: "contact",
    component: Contact,
    meta: { publicpage: true }
  },
  {
    path: "/partners",
    name: "partners",
    component: Partners,
    meta: { publicpage: true }
  },
  {
    path: "/sitemap",
    name: "sitemap",
    component: Sitemap,
    meta: { publicpage: true }
  },
  {
    path: "/agence",
    name: "agence",
    component: Whoweare,
    meta: { publicpage: true }
  },
  {
    path: "/legalnotice",
    name: "legalnotice",
    component: LegalNotice,
    meta: { publicpage: true }
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: { publicpage: true }
  },
  {
    path: "/resetpass/:co_id/:challenge",
    name: "resetpass",
    component: Login,
    meta: { publicpage: true }
  },

  {
    path: "/extranet",
    beforeEnter(to, from, next) {
      // Put the full page URL including the protocol http(s) below
      window.location.replace("https://immonaco.pvnrealestate.com");
    }
  },
  {
    path: "*",
    name: "homeredirect",
    // component: Home
    redirect: "/"
  }

  /*   {
    path: "/public/contact",
    name: "homepublicontact",
    component: HomePublicContact,
    meta: { publicpage: true }
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: { publicpage: true }
  },
  {
    path: "/register",
    name: "register",
    component: Register,
    meta: { publicpage: true }
  }, */
  /*  {
    path: "/subscribe",
    name: "subscribe",
    component: Subscribe,
    meta: { publicpage: true }
  },

  {
    path: "/homeprive",
    name: "homeprive",
    component: HomePrive,
    meta: { menu: "home" }
  },
  {
    path: "/dossier/:fd_id",
    name: "dossier",
    component: Patient,
    meta: { menu: "dossier" }
  },
  {
    path: "/patients",
    name: "patients",
    component: Patients,
    meta: { menu: "patients" }
  },
  {
    path: "/patients/:fd_id",
    name: "patient",
    component: Patient,
    meta: { menu: "patients" }
  }, */
  /*   {
    path: "/patients/:fd_id/print",
    name: "patientprint",
    component: PatientPrint,
    meta: { menu: "print" }
  }, */
  /* {
    path: "/patients/:id/bilan",
    name: "patientbilan",
    component: Patient
  },
  {
    path: "/patients/:id/questionnaires",
    name: "patientquestionnaires",
    component: Patient
  },
  {
    path: "/patients/:id/protocol",
    name: "patientprotocol",
    component: Patient
  },
  {
    path: "/patients/:id/objective",
    name: "patientobjective",
    component: Patient
  },
  {
    path: "/patients/:id/messages",
    name: "patientmessages",
    component: Patient
  }, */
];

const router = new VueRouter({
  mode: "history",
  routes
});
router.traductionLoaded = false;

router.beforeEach(async (to, from, next) => {
  async function autolog() {
    // console.log("je passe", Vue.prototype.$config);
    try {
      let response = await axios.post(
        Vue.prototype.$config.server_url + "/web/1.0/autosignin",
        {
          accesstoken: store.state.accesstoken
        }
      );
      // console.log("autolog - response.data : ", response.data);
      if (response.data.err) {
        return false;
      }
      store.commit("set_connexion", {
        accesstoken: response.data.accesstoken,
        user: response.data.data
        // offers: response.data.data.rows_ac
      });
      return true;
    } catch (error) {
      console.error("ko", error);
      return false;
    }
  }

  async function loadItems() {
    try {
      let response = await axios.get(
        Vue.prototype.$config.server_url + "/web/1.0/items",
        {}
      );
      if (response.data.err) return false;
      store.commit("set_items", {
        items: response.data.data
      });
    } catch (error) {
      console.error("ko", error);
    }
  }
  async function loadTraductions() {
    try {
      let response = await axios.get(
        Vue.prototype.$config.server_url + "/web/1.0/trads",
        {}
      );
      if (response.data.err) return false;
      store.commit("set_traductions", {
        traductions: response.data.data
      });
      router.traductionLoaded = true;
    } catch (error) {
      console.error("ko", error);
    }
  }

  if (!store.state.itemsloaded) await loadItems();
  //if (!store.state.traductionsloaded) await loadTraductions();
  // console.log("router.traductionLoaded", router.traductionLoaded);
  if (!router.traductionLoaded) await loadTraductions();

  // if (to.meta.readUrlSchool) {
  //   let schoolslug = "";
  //   if (to.params.schoolslug) schoolslug = to.params.schoolslug;
  //   store.commit("set_currentschool", schoolslug);
  // }

  let user = JSON.parse(localStorage.getItem("pvn-web-user"));

  if (!store.state.connected && user) await autolog();
  /*   async function autolog() {
    if (!store.state.accesstoken) return false;
    if (store.state.connected) return true;
    try {
      let response = await axios.post(
        config.server_url + "/api/1.0/autosignin",
        {
          accesstoken: store.state.accesstoken
        }
      );
      if (response.data.err) {
        return false;
      }
      store.commit("set_connexion", {
        accesstoken: response.data.accesstoken,
        refreshtoken: response.data.refreshtoken,
        user: response.data.data,
        preferences: response.data.preferences
      });
      return true;
    } catch (error) {
      console.error("ko", error);
      return false;
    }
  }

  // console.log("to, from", to, from);
  if (to.meta && to.meta.publicpage && to.name != "login") return next();

  // if (to.name == "resetpass") return next();


  if (to.name == "login") {
    if (store.state.connected) return next({ path: "/homeprive" });
    return next();
  }
  if (!store.state.connected) return next({ path: "/login" }); */
  window.scrollTo(0, 0);

  return next();
});

export default router;
